import { getSimpleBoard } from "./board/getSimpleBoard";
import { calcBoardParamFromDiagonal } from "./func/calcBoardParamFromDiagonal";
import { calcSegmentsWithPoints } from "./func/calcSegmentsWithPoints";
import { calcPlaceFromDiagonal } from "./func/calcPlaceFromDiagonal";
import { updateLimitedPointsOnLine } from "./func/updateLimitedPointsOnLine";
import { calcPositionFromSegmentsLength } from "./func/calcPositionFromSegmentsLength";
import { calcCountInLength } from "./func/calcCountInLength";
import { centeredPointsOnLine } from "./func/centeredPointsOnLine";
import { calcColumnLine } from "./func/calcColumnLine";
import { placeOnPlan } from "./func/placeOnPlan";
import { calculationSave } from "./calculation/save";
import { fillers } from './fillers/fillers';
import { getBaseMaterials, getMaterials } from "./matherial/getMaterials";
import { getCornerPostOnPlace } from "./3dp";
import { getSpec } from "./spec/getSpec";
export function createApi(client) {
    return {
        calcColumnLine: calcColumnLine(client),
        centeredPointsOnLine: centeredPointsOnLine(client),
        placeOnPlan: placeOnPlan(client),
        getSimpleBoard: getSimpleBoard(client),
        getMaterials: getMaterials(client),
        getBaseMaterials: getBaseMaterials(client),
        calcCountInLength: calcCountInLength(client),
        getSpec: getSpec(client),
        calcPositionFromSegmentsLength: calcPositionFromSegmentsLength(client),
        updateLimitedPointsOnLine: updateLimitedPointsOnLine(client),
        calcSegmentsWithPoints: calcSegmentsWithPoints(client),
        calcPlaceFromDiagonal: calcPlaceFromDiagonal(client),
        calcBoardParamFromDiagonal: calcBoardParamFromDiagonal(client),
        calculationSave: calculationSave(client),
        fillers: fillers(client),
        getCornerPostOnPlace: getCornerPostOnPlace(client),
    };
}
